import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useEffect, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import Storage from '@outdoor-voices/ui/dist/utils/Storage';
import { getAccessToken } from '../../customers/utils';
import { HIDE_OVID_MODAL, SHOW_OVID_MODAL } from '@outdoor-voices/ui/dist/config/constants';
import { wishListItemAddMutation, withListItemDeleteMutation } from './queries';
import css from './WishListItemToggle.module.scss';
import HeartFilledIcon from '../../../components/icons/HeartFilled';
import HeartIcon from '../../../components/icons/Heart';
import OVIDClient from '../../customers/OVIDClient';
import WishListCache from '../../customers/WishListCache';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var COOKIE = 'ov-wish-listed-colorway-id';

var WishListItemToggle = function WishListItemToggle(_ref) {
  var _ref5;

  var colorwayColor = _ref.colorwayColor,
      colorwayId = _ref.colorwayId,
      initialFilledIn = _ref.initialFilledIn,
      listItem = _ref.listItem,
      onPLP = _ref.onPLP,
      productId = _ref.productId,
      productTitle = _ref.productTitle,
      setShowHeart = _ref.setShowHeart;

  var _useState = useState(initialFilledIn),
      _useState2 = _slicedToArray(_useState, 2),
      filledIn = _useState2[0],
      setFilledIn = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      requesting = _useState4[0],
      setRequesting = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loggingIn = _useState6[0],
      setLoggingIn = _useState6[1];

  var _useState7 = useState(getAccessToken()),
      _useState8 = _slicedToArray(_useState7, 2),
      loggedIn = _useState8[0],
      setLoggedIn = _useState8[1];

  var onWishListItemAdd = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var client, response, cache, storage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setRequesting(true); // Toggle value of filledIn to switch icon

            setFilledIn(true);

            if (setShowHeart) {
              setShowHeart(true);
            } // Add item to cache


            client = new OVIDClient();
            _context.next = 6;
            return client.mutate(wishListItemAddMutation, {
              emsColorwayGid: colorwayId,
              emsProductGid: productId
            });

          case 6:
            response = _context.sent;
            cache = new WishListCache();
            cache.update(response.data.wishListItemAdd);
            setRequesting(false); // Clear cookie

            storage = new Storage();
            storage.remove(COOKIE);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [colorwayId, productId, setShowHeart]); // If already logged in

  useEffect(function () {
    if (!loggedIn) {
      return;
    } // Check the colorway cookie


    var storage = new Storage();
    var cookie = storage.get(COOKIE);

    if (!cookie || cookie !== colorwayId) {
      return;
    } // Add item to cache


    onWishListItemAdd();
  }, [loggedIn, colorwayId, onWishListItemAdd]); // If attempting login

  useEffect(function () {
    if (!loggingIn || loggedIn) {
      return;
    } // Set colorway id in storage


    var storage = new Storage();
    storage.set(COOKIE, colorwayId); // Trigger modal event

    var modalEventShow = new CustomEvent(SHOW_OVID_MODAL, {
      detail: {}
    });
    window.dispatchEvent(modalEventShow);

    var onLoginHide = function onLoginHide() {
      setLoggingIn(false);
    };

    var handleMessage = function handleMessage(_ref3) {
      var data = _ref3.data;

      if (!data || typeof data !== 'string') {
        return;
      } // eslint-disable-next-line no-unused-vars


      var _data$split = data === null || data === void 0 ? void 0 : data.split('::'),
          _data$split2 = _slicedToArray(_data$split, 2),
          key = _data$split2[0],
          _ = _data$split2[1];

      if (key !== 'OVID') {
        return;
      }

      setLoggedIn(true);

      if (onPLP) {
        window.location.reload();
      }
    }; // Listen for modal events


    var message = 'message';
    window.addEventListener(message, handleMessage, false);
    window.addEventListener(HIDE_OVID_MODAL, onLoginHide, false);
    return function () {
      // Remove listeners
      window.removeEventListener(HIDE_OVID_MODAL, onLoginHide);
      window.removeEventListener(message, handleMessage);
    };
  }, [loggedIn, loggingIn, colorwayId, onWishListItemAdd, onPLP]);

  var onWishListItemDelete = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var currentWishList, id, client, response, cache;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setRequesting(true); // Remove item from cache

              currentWishList = new WishListCache().get();
              id = currentWishList.colorways[colorwayId];
              client = new OVIDClient();
              _context2.next = 6;
              return client.mutate(withListItemDeleteMutation, {
                id: id
              });

            case 6:
              response = _context2.sent;
              cache = new WishListCache();
              cache.update(response.data.wishListItemDelete); // Toggle value of filledIn to switch icon

              setFilledIn(false);

              if (setShowHeart) {
                setShowHeart(false);
              }

              setRequesting(false);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onWishListItemDelete() {
      return _ref4.apply(this, arguments);
    };
  }();

  var getOnClick = function getOnClick() {
    if (!loggedIn) {
      return function () {
        setLoggingIn(true);
      };
    }

    return filledIn ? onWishListItemDelete : onWishListItemAdd;
  };

  var ariaLabel = filledIn ? "Click to remove ".concat(productTitle, " in ").concat(colorwayColor, " from your wish list") : "Click to add ".concat(productTitle, " in ").concat(colorwayColor, " to your wish list");
  return /*#__PURE__*/_jsxs("button", {
    "aria-label": ariaLabel,
    className: cc([css.heartButton, (_ref5 = {}, _defineProperty(_ref5, css.listItem, listItem), _defineProperty(_ref5, css.filled, filledIn), _ref5)]),
    disabled: requesting,
    onClick: getOnClick(),
    children: [filledIn && /*#__PURE__*/_jsx(HeartFilledIcon, {}), !filledIn && /*#__PURE__*/_jsx(HeartIcon, {})]
  });
};

WishListItemToggle.propTypes = {
  initialFilledIn: PropTypes.bool.isRequired,
  listItem: PropTypes.bool,
  onPLP: PropTypes.bool,
  productId: PropTypes.string.isRequired,
  productTitle: PropTypes.string,
  setShowHeart: PropTypes.func,
  colorwayId: PropTypes.string.isRequired,
  colorwayColor: PropTypes.string
};
export default WishListItemToggle;